import { achievementsActionTypes } from './constants';
import { AchievementsState } from '../types';

const initialState: AchievementsState = {
	loading: false,
	categories: [],
	activeCategoryId: null,
	achievements: {},
};

export default function achievementsReducer(state = initialState, action: any) {
	const { type, payload } = action;
	const { categoryId, categories, achievements } = payload || {};

	switch (type) {
		case achievementsActionTypes.GET_CATEGORIES_REQUEST:
			return {
				...state,
				loading: true,
			};

		case achievementsActionTypes.GET_CATEGORIES_SUCCESS:
			return {
				...state,
				categories,
				loading: false,
			};

		case achievementsActionTypes.GET_CATEGORIES_ERROR:
			return {
				...state,
				loading: false,
			};

		case achievementsActionTypes.GET_ACHIEVEMENTS_SUCCESS:
			return {
				...state,
				achievements,
				loading: false,
			};

		case achievementsActionTypes.GET_ACHIEVEMENTS_ERROR:
			return {
				...state,
				loading: false,
			};

		case achievementsActionTypes.SET_ACTIVE_CATEGORY_ID:
			return {
				...state,
				activeCategoryId: categoryId,
			};

		case achievementsActionTypes.RESET_ACHIEVEMENTS:
			return {
				...initialState,
			};

		default:
			return state;
	}
}
